@let otherTotal = totalSegments - 2; <!-- exclude country and platform -->
@let country = segmentParts().country;
@let platform = segmentParts().platform;
@let others = segmentParts().other;
@let wrapperClass = {
    default: 'flex-wrap border rounded-md hover:shadow-sm divide-x divide-y bg-gray-50/70 divide-gray-100 overflow-hidden border-gray-300',
    secondary: 'rounded-full text-black px-0.5'
  }[variant];
  <div class="text-xs inline-flex"
    [class]="wrapperClass"
    [class.bg-gray-100]="!invalid"
    [class.bg-orange-100]="invalid">
    <div [ngClass]="{
      default: 'py-1.5 px-2 flex items-center gap-1.5 font-medium',
      secondary: 'py-0.5 px-1.5 flex items-center gap-1.5 font-medium rounded-md'
    }[variant]">
      @if (country && !invalid) {
        <span [class]="country | flag"></span>
      }
      <span>{{country}}</span>
    </div>
    <div [ngClass]="{
        default: 'py-1.5 px-2 flex items-center gap-1.5 font-medium',
        secondary: 'py-0.5 px-1.5 flex items-center gap-1.5 font-medium rounded-md'
      }[variant]" [class.hidden]="!platform">
      {{platform}}
    </div>

    @for (other of others; track other; let idx = $index) {
      @if(idx < otherTotal) {
        <div data-cy="other-segment-part"
        [ngClass]="{
          default: 'py-1.5 px-2 flex items-center gap-1.5 font-medium',
          secondary: 'py-0.5 px-1.5 flex items-center gap-1.5 font-medium rounded-md'
        }[variant]">
          <span [appTooltip]="other" [tooltipAutoToggle]="true"
            [class.text-ellipsis]="others.length <= otherTotal"
            [ngClass]="{'overflow-hidden block': truncate}"
            [ngStyle]="{'max-width': (truncate ? maxWidth + 'px' : 'auto')}">
            <span data-tooltip-text class="break-normal whitespace-nowrap">
              {{other}}
            </span>
          </span>
        </div>
      }
    }
    @if(others.length > otherTotal) {
      <div data-cy="other-segment-part" [appTooltip]="others.slice(otherTotal).join(', ')"
        [ngClass]="{
          default: 'py-1.5 px-2 flex items-center last:bg-white gap-1.5 font-medium',
          secondary: 'py-0.5 px-1.5 flex items-center gap-1.5 font-medium rounded-md'
        }[variant]">
        ...
      </div>
  }
  </div>
